var map = {
	"./bialystok/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		86569,
		86569
	],
	"./bydgoszcz/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		59106,
		59106
	],
	"./czestochowa/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		78455,
		78455
	],
	"./garwolin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		96715,
		96715
	],
	"./gdansk/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		12665,
		12665
	],
	"./gdynia/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		79129,
		79129
	],
	"./gliwice/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		20225,
		20225
	],
	"./gmina-swidnica/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		49476,
		49476
	],
	"./kielce/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		7862,
		7862
	],
	"./kolobrzeg/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		83552,
		83552
	],
	"./konskowola/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		46409,
		46409
	],
	"./koszalin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		66606,
		66606
	],
	"./lask/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		32666,
		32666
	],
	"./lodz/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		55860,
		55860
	],
	"./lublin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		49897,
		49897
	],
	"./miejsce-piastowe/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		80928,
		80928
	],
	"./mikolow/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		78649,
		78649
	],
	"./naklo/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		10232,
		10232
	],
	"./oborniki/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		84110,
		84110
	],
	"./olesnica/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		58433,
		58433
	],
	"./postomino/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		74477,
		74477
	],
	"./poznan/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		45061,
		45061
	],
	"./przechlewo/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		84398,
		84398
	],
	"./radom/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		71192,
		71192
	],
	"./raszkow/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		14148,
		14148
	],
	"./rawicz/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		36235,
		36235
	],
	"./ryman/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		13260,
		13260
	],
	"./sierakowice/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		14583,
		14583
	],
	"./slawno/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		33247,
		33247
	],
	"./slawoborze/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		35237,
		35237
	],
	"./stare-babice/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		75061,
		75061
	],
	"./szczecin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		32439,
		54820
	],
	"./szemud/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		82237,
		82237
	],
	"./warszawa/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		55641,
		55641
	],
	"./wloszczowa/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		40738,
		40738
	],
	"./wroclaw/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		7842,
		7842
	],
	"./wyszkow/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		92387,
		92387
	],
	"./zukowo/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx": [
		55262,
		55262
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28072;
module.exports = webpackAsyncContext;